class ShopsByCityOrDistrictCtrl {
    constructor($scope, $stateParams, storeServ, helperServ, shopTypesServ) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.storeServ = storeServ;
        this.helperServ = helperServ;
        this.shopTypesServ = shopTypesServ;
        this.district = $stateParams.district;
        this.city = $stateParams.city;
        this.setBreadcrumbs();
        this.getBounds();
        this.storeServ.dispatch({
            type: 'SET_SHOP_TYPE',
            shopType: {
                context: this.shopTypesServ.getContextShops(),
                typeFilters: [],
                subTypeFilters: []
            }
        });
        this.addComponentDestroyListener();
    }

    /**
     *  Init.
     */

    setBreadcrumbs() {
        this.breadcrumbs = [{
            text: 'home',
            state: 'home',
            params: null
        }];

        if (this.district) {
            this.breadcrumbs.push({
                text: this.district,
                state: 'shops-by-district',
                params: {
                    district: this.district
                }
            });
        }

        if (this.city) {
            this.breadcrumbs.push({
                text: this.city,
                state: 'shops-by-city',
                params: {
                    district: this.district,
                    city: this.city
                }
            });
        }
    }

    getBounds() {
        let geocoder = new google.maps.Geocoder();
        let district = (this.$stateParams.district === 'Bucuresti') ? 'Municipiul Bucuresti, Romania' : 'Judetul ' + this.$stateParams.district + ', Romania';
        let city = this.$stateParams.city;
        let address = city ? city + ', ' + district : district;

        geocoder.geocode({
            'address': address
        }, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {

                let place = results[0];

                this.storeServ.dispatch({
                    type: 'SET_BOUNDS_TO_HIGHLIGHT',
                    boundsToHighlight: this.helperServ.getLiteralBounds(place.geometry.viewport)
                });

                this.storeServ.dispatch({
                    type: 'SET_SEARCHED_PLACE_COORDINATES',
                    searchedPlaceCoordinates: {
                        location: {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng()
                        },
                        viewport: this.helperServ.getLiteralBounds(place.geometry.viewport)
                    }
                });
            }
        });
    }

    addComponentDestroyListener() {
        this.$scope.$on('$destroy', this.onDestroyComponent.bind(this));
    }

    /**
     *  Listeners.
     */

    onDestroyComponent() {
        this.storeServ.getState().boundsToHighlight && this.storeServ.dispatch({
            type: 'SET_BOUNDS_TO_HIGHLIGHT',
            boundsToHighlight: null
        });

        this.storeServ.getState().shopType && this.storeServ.dispatch({
            type: 'SET_SHOP_TYPE',
            shopType: {
                context: '',
                typeFilters: [],
                subTypeFilters: []
            }
        });
    }
}

ShopsByCityOrDistrictCtrl.$inject = ['$scope', '$stateParams', 'storeServ', 'helperServ', 'shopTypesServ'];

export default ShopsByCityOrDistrictCtrl;
